import {
  resolveVariantFresh,
  mergeQuizAnswersWithQueryParams,
} from "./conversion-flow.resolve-variant.js";
import { svgCheck, svgMinus, svgMore } from "./conversion-flow.svgs.js";
import cartState from "./conversion-flow.cart-state.js";

class CFBuyCardFresh extends HTMLElement {
  #variants;
  #currentVariantData;
  #quantity = 1;

  #elementPriceDisplay;
  #elementOriginalPriceDisplay;
  #elementCheckbox;
  #elementQuantityDisplay;
  #elementQuantityMinus;
  #elementQuantityMore;

  constructor() {
    super();
    this.#variants = JSON.parse(this.dataset.variants);
  }

  connectedCallback() {
    const quizAnswers = mergeQuizAnswersWithQueryParams(
      Shopify.designMode
        ? { weight: this.dataset.previewWeight }
        : QuizStorage.getQuizAnswers(),
    );
    this.#currentVariantData = this.#variants[0];
    this.#quantity = resolveVariantFresh(this.#variants, quizAnswers);
    this.render();
    this.updateCta();
  }

  render() {
    const images = JSON.parse(this.dataset.images);
    const title = this.dataset.title;
    const cardLabel = this.dataset.cardLabel || "Base Fresca";
    const imageSrc = images[0]?.src ?? images[0] ?? "";

    const bullet_points = (
      this.#currentVariantData.metafields?.bullet_points ?? []
    )
      .map(
        (text) => html`
          <div class="body-list-item">
            <div class="bullet-point">${svgCheck}</div>
            <span class="list-item-text">${text}</span>
          </div>
        `,
      )
      .join("");

    const price =
      this.#currentVariantData.selling_plan_allocations?.[0]?.price ??
      this.#currentVariantData.price;

    const original_price = this.#currentVariantData.price;

    const showOriginalPrice = price !== original_price;

    this.innerHTML = html`
      <div class="product-card" for="buy-card-fresh">
        <div class="product-card-header">
          <span class="title">${cardLabel}</span>
          <span class="original-price">
            ${showOriginalPrice
              ? `€${((original_price * this.#quantity) / 100)
                  .toFixed(2)
                  .replace(".", ",")}`
              : ""}
          </span>
          <span class="price"
            >€${((price * this.#quantity) / 100).toFixed(2).replace(".", ",")}
          </span>
          <label class="check">
            <input type="checkbox" checked="true" style="display:none;" />
            ${svgCheck}
          </label>
        </div>

        <div class="product-card-body">
          <div class="product-card-details">
            <span class="body-title">${title}</span>
            <span class="body-subtitle"
              >${this.#currentVariantData.metafields?.subtitle ?? ""}</span
            >
            <div class="body-list">${bullet_points}</div>
          </div>
          <div class="product-image">
            <img src="${imageSrc}" alt="${title}" />
          </div>
        </div>

        <div class="product-card-footer">
          <div class="size-selector-row">
            <div class="input-number-wrapper">
              <div class="input-control ip-minus">${svgMinus}</div>
              <span class="input-display">${this.#quantity}</span>
              <div class="input-control ip-more">${svgMore}</div>
            </div>
          </div>
          <span class="suggested-amount">
            Quantidade sugerida para usar em 30 refeições ou mais:
            ${this.#quantity} unidades
          </span>
        </div>
      </div>
    `;

    this.#elementPriceDisplay = this.querySelector(
      ".product-card .product-card-header .price",
    );
    this.#elementOriginalPriceDisplay = this.querySelector(
      ".product-card .product-card-header .original-price",
    );
    this.#elementCheckbox = this.querySelector("input[type=checkbox]");
    this.#elementQuantityMinus = this.querySelector(
      ".product-card-footer .input-control.ip-minus",
    );
    this.#elementQuantityMore = this.querySelector(
      ".product-card-footer .input-control.ip-more",
    );
    this.#elementQuantityDisplay = this.querySelector(
      ".product-card-footer .input-display",
    );

    this.#elementCheckbox.addEventListener(
      "change",
      this.onCheckboxChange.bind(this),
    );
    this.#elementQuantityMinus.addEventListener("click", () =>
      this.onQuantityUpdate(this.#quantity - 1),
    );
    this.#elementQuantityMore.addEventListener("click", () =>
      this.onQuantityUpdate(this.#quantity + 1),
    );
  }

  onQuantityUpdate(newQuantity) {
    if (newQuantity < 1) return;
    this.#quantity = newQuantity;
    this.#elementQuantityDisplay.textContent = this.#quantity;
    const price =
      this.#currentVariantData.selling_plan_allocations?.[0]?.price ??
      this.#currentVariantData.price;
    const original_price = this.#currentVariantData.price;
    const showOriginalPrice = price !== original_price;

    this.#elementPriceDisplay.textContent = `€${((price * this.#quantity) / 100).toFixed(2).replace(".", ",")}`;
    this.#elementOriginalPriceDisplay.textContent = showOriginalPrice
      ? `€${((original_price * this.#quantity) / 100).toFixed(2).replace(".", ",")}`
      : "";

    this.updateCta();
  }

  onCheckboxChange() {
    this.updateCta();
  }

  updateCta() {
    const original_price = this.#currentVariantData.price;
    const price =
      this.#currentVariantData.selling_plan_allocations?.[0]?.price ??
      this.#currentVariantData.price;
    cartState.update("FRESH", {
      checked: this.#elementCheckbox.checked,
      original_price: original_price * this.#quantity,
      price: price * this.#quantity,
      quantity: this.#quantity,
      variantId: this.#currentVariantData.id,
      selling_plan:
        this.#currentVariantData.selling_plan_allocations?.[0]?.selling_plan_id,
    });
  }
}

if (!customElements.get("cf-buy-card-fresh")) {
  customElements.define("cf-buy-card-fresh", CFBuyCardFresh);
}
